import { Field, ErrorMessage } from "formik";

const inputClass =
  "w-full rounded-md border border-input bg-background p-2 text-foreground focus:border-ring focus:ring-1 focus:ring-ring";

function Row({ name, label, type = "text", placeholder, required, as }) {
  return (
    <div>
      <label htmlFor={name} className="mb-1 block text-sm text-foreground">
        {label}
        {required && <span className="text-destructive"> *</span>}
      </label>
      <Field
        id={name}
        name={name}
        type={type}
        as={as}
        rows={as === "textarea" ? 3 : undefined}
        placeholder={placeholder}
        className={inputClass}
      />
      <ErrorMessage name={name} component="p" className="mt-1 text-xs text-destructive" />
    </div>
  );
}

/**
 * Contact and delivery details, collected at order time because there is no
 * account to read them from.
 */
export function CheckoutFields({ showNotes = true }) {
  return (
    <div className="space-y-4">
      <fieldset className="space-y-3">
        <legend className="mb-1 text-sm font-semibold text-foreground">Your details</legend>
        <Row name="customer_name" label="Full name" required placeholder="Ayesha Khan" />
        <Row
          name="customer_email"
          label="Email"
          type="email"
          required
          placeholder="you@example.com"
        />
        <p className="text-xs text-muted-foreground">
          We send your confirmation and a private link to check this order here — no
          password needed, so keep that email.
        </p>
        <Row name="customer_phone" label="Phone" placeholder="+92 300 1234567" />
      </fieldset>

      <fieldset className="space-y-3">
        <legend className="mb-1 text-sm font-semibold text-foreground">Delivery address</legend>
        <Row name="address_line1" label="Address line 1" placeholder="12 Maple Street" />
        <Row name="address_line2" label="Address line 2" placeholder="Apt 4B (optional)" />
        <div className="grid gap-3 sm:grid-cols-2">
          <Row name="city" label="City" placeholder="Toronto" />
          <Row name="state" label="State / Province" placeholder="ON" />
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          <Row name="postal_code" label="Postal code" placeholder="M5V 2T6" />
          <Row name="customer_country" label="Country" placeholder="Canada" />
        </div>
      </fieldset>

      {showNotes && (
        <Row
          name="notes"
          label="Notes"
          as="textarea"
          placeholder="Size, colour, quantity, or anything else…"
        />
      )}
    </div>
  );
}

export default CheckoutFields;
